import { Link } from "react-router-dom";
import { logoPath } from "../data/site";

type LogoProps = {
  compact?: boolean;
};

export function Logo({ compact = false }: LogoProps) {
  return (
    <Link
      to="/"
      className="group inline-flex items-center gap-3"
      aria-label="Lazerwebs home"
    >
      <span className="relative grid h-11 w-11 shrink-0 place-items-center overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-glow">
        <img
          src={logoPath}
          alt="Lazerwebs logo"
          className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
        />
      </span>
      {!compact && (
        <span className="leading-none">
          <span className="block font-display text-lg font-semibold text-white">
            Lazerwebs
          </span>
          <span className="mt-1 block text-[11px] uppercase tracking-[0.22em] text-white/45">
            Digital Solutions
          </span>
        </span>
      )}
    </Link>
  );
}
